const FIELD_ALIASES = {
  ofscNr: ['OFSC_NR', 'OfscNr', 'ofscNr'],
  techCode: ['TEKNISYEN_KODU', 'TechCode', 'techCode'],
  userTechCode: ['KUL_TEK_KODU', 'UserTechCode', 'userTechCode'],
  techName: ['TEKNISYEN_ADI', 'TechName', 'techName'],
  appointmentDate: ['RANDEVU_TARIHI', 'RandevuTarihi', 'randevuTarihi', 'AppointmentDate', 'appointmentDate'],
  appointmentEndText: ['RANDEVU_TARIHI_BITIS_STR', 'RandevuTarihiBitisStr', 'randevuTarihiBitisStr', 'AppointmentDateEndText', 'appointmentDateEndText'],
  toaStatus: ['TOA_DURUM', 'toa_durum', 'ToaDurum', 'toaDurum', 'ToaStatus', 'toaStatus'],
  neighbourhood: ['Neighbourhood', 'Neighborhood', 'NEIGHBOURHOOD', 'MAHALLE'],
  latitude: ['LATITUDE', 'Latitude', 'latitude'],
  longitude: ['LONGITUDE', 'Longitude', 'longitude'],
  workDuration: [
    'SURE', 'SÜRE', 'Sure', 'Süre', 'sure',
    'WorkDuration', 'workDuration', 'WORK_DURATION',
    'CalculatedDuration', 'CALCULATED_DURATION',
    'PlannedWorkDuration', 'plannedWorkDuration',
    'Duration', 'duration',
  ],
  techWorkStart: ['TechWorkStart', 'TECH_WORK_START', 'techWorkStart'],
  techWorkEnd: ['TechWorkEnd', 'TECH_WORK_END', 'techWorkEnd'],
  rowNum: ['RowNum', 'ROW_NUM', 'rowNum'],
  appointmentTime: ['RANDEVU_SAAT', 'RandevuSaat', 'randevuSaat', 'AppointmentTime', 'appointmentTime'],
  appointmentTimeEnd: ['RANDEVU_SAAT_BITIS', 'RandevuSaatBitis', 'randevuSaatBitis', 'AppointmentTimeEnd', 'appointmentTimeEnd'],
  departedAt: ['YOLACIKILDI', 'YolaCikildi', 'DepartureTime', 'departureTime'],
  startedAt: ['BASLANDI', 'Baslandi', 'ArrivalatCustomer', 'arrivalatCustomer'],
  completedAt: ['TAMAMLANDI', 'Tamamlandi', 'TaskCompletionTime', 'taskCompletionTime'],
  statusDescription: ['StatusDescription', 'statusDescription', 'TOA_DURUM_ACIKLAMA'],
  products: ['Products', 'products', 'BundleUrunler', 'bundleUrunler', 'URUNLER'],
  servicePapers: [
    'ServicePapers', 'servicePapers', 'FisNoDetay', 'fisNoDetay',
    'FIS_NO_DETAY', 'ServicePaperDetail', 'servicePaperDetail',
  ],
  servicePapersStatus: [
    'ServicePapersStatus', 'servicePapersStatus',
    'FisDurumListesi', 'fisDurumListesi',
  ],
  dealer: [
    'Dealer', 'dealer', 'DealerName', 'dealerName',
    'Bayi', 'BAYI', 'BayiName', 'bayiName',
  ],
  customer: [
    'Customer', 'customer', 'CustomerName', 'customerName',
    'Musteri', 'MUSTERI', 'Müşteri',
  ],
  appReason: [
    'AppReason', 'appReason', 'APP_REASON',
    'ApplicationReason', 'applicationReason',
    'ApplicationReasonId', 'applicationReasonId',
  ],
};

const DEFAULT_STATUS_DESCRIPTIONS = {
  0: 'Bucket',
  1: 'cancelled',
  2: 'notdone',
  3: 'pending',
  4: 'started',
  5: 'suspended',
  6: 'completed',
  7: 'Road',
  8: 'notdone',
};

const readField = (row, aliases) => {
  for (const alias of aliases) {
    if (Object.prototype.hasOwnProperty.call(row, alias)) return row[alias];
  }
  return undefined;
};

const isNullishValue = (value) => (
  value === undefined
  || value === null
  || String(value).trim() === ''
  || String(value).trim().toUpperCase() === 'NULL'
  || String(value).trim() === '-'
);

const parseLocaleNumber = (value) => {
  if (isNullishValue(value)) return null;
  const normalized = String(value).trim().replace(/\s+/g, '').replace(',', '.');
  const parsed = Number(normalized);
  return Number.isFinite(parsed) ? parsed : null;
};

const parseInteger = (value, fallback = 0) => {
  const parsed = parseLocaleNumber(value);
  if (parsed != null) return Math.trunc(parsed);
  const timeMinutes = parseTimeMinutes(value);
  return timeMinutes == null ? fallback : Math.trunc(timeMinutes);
};

export const resolveToaStatusDescription = (value, fallback = '') => {
  const statusCode = parseInteger(value, null);
  return DEFAULT_STATUS_DESCRIPTIONS[statusCode] || fallback;
};

const normalizeTextValue = (value) => {
  if (isNullishValue(value)) return '';
  if (Array.isArray(value)) {
    return value
      .flat(Infinity)
      .filter(item => !isNullishValue(item))
      .map(item => String(item).trim())
      .join(',');
  }
  return String(value).trim();
};

const parseTimeMinutes = (value) => {
  if (isNullishValue(value)) return null;
  if (value instanceof Date && !Number.isNaN(value.getTime())) {
    return value.getHours() * 60 + value.getMinutes() + value.getSeconds() / 60;
  }
  const text = String(value).trim();
  const timeMatch = text.match(/(?:T|\s|^)(\d{1,2}):(\d{2})(?::(\d{2}(?:\.\d+)?))?/);
  if (!timeMatch) return null;
  const hours = Number(timeMatch[1]);
  const minutes = Number(timeMatch[2]);
  const seconds = Number(timeMatch[3] || 0);
  if (hours > 23 || minutes > 59 || seconds >= 60) return null;
  return hours * 60 + minutes + seconds / 60;
};

const startOfLocalDay = (value) => {
  const date = value instanceof Date ? new Date(value) : new Date(value);
  if (Number.isNaN(date.getTime())) return null;
  date.setHours(0, 0, 0, 0);
  return date;
};

const parseLocalDateTime = (value, fallbackDay, fallbackMinutes = null) => {
  if (value instanceof Date && !Number.isNaN(value.getTime())) return new Date(value);
  if (!isNullishValue(value)) {
    const text = String(value).trim();
    const match = text.match(/^(\d{4})-(\d{2})-(\d{2})(?:[T\s](\d{1,2}):(\d{2})(?::(\d{2}))?)?/);
    if (match) {
      return new Date(
        Number(match[1]),
        Number(match[2]) - 1,
        Number(match[3]),
        Number(match[4] || 0),
        Number(match[5] || 0),
        Number(match[6] || 0),
        0,
      );
    }
    const parsed = new Date(text);
    if (!Number.isNaN(parsed.getTime())) return parsed;
  }
  if (fallbackDay && fallbackMinutes != null) return dateAtMinutes(fallbackDay, fallbackMinutes);
  return null;
};

const dateAtMinutes = (day, minutes) => {
  if (!day || minutes == null || !Number.isFinite(minutes)) return null;
  return new Date(day.getTime() + Math.round(minutes * 60000));
};

const addMinutes = (date, minutes) => (
  date && Number.isFinite(minutes) ? new Date(date.getTime() + minutes * 60000) : null
);

const maxDate = (...dates) => {
  const validDates = dates.filter(date => date instanceof Date && !Number.isNaN(date.getTime()));
  return validDates.length ? new Date(Math.max(...validDates.map(date => date.getTime()))) : null;
};

const sameLocalDay = (first, second) => (
  first
  && second
  && first.getFullYear() === second.getFullYear()
  && first.getMonth() === second.getMonth()
  && first.getDate() === second.getDate()
);

const formatTime = (date) => {
  if (!(date instanceof Date) || Number.isNaN(date.getTime())) return '-';
  return `${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}`;
};

// SQL Server DATEDIFF(MINUTE) geçen dakika sınırlarını sayar.
const diffSqlMinutes = (start, end) => {
  if (!start || !end) return 0;
  return Math.floor(end.getTime() / 60000) - Math.floor(start.getTime() / 60000);
};

const statusPriority = (status) => {
  if (status === 6) return 100;
  if (status === 4) return 50;
  if (status === 7) return 10;
  return 1;
};

const lastLocationPriority = (status) => {
  if (status === 6) return 3;
  if (status === 4) return 2;
  if (status === 7) return 1;
  return 0;
};

const compareNullableNumbers = (first, second) => {
  if (first == null && second == null) return 0;
  if (first == null) return 1;
  if (second == null) return -1;
  return first - second;
};

const compareDates = (first, second) => {
  const firstTime = first instanceof Date ? first.getTime() : Number.POSITIVE_INFINITY;
  const secondTime = second instanceof Date ? second.getTime() : Number.POSITIVE_INFINITY;
  return firstTime - secondTime;
};

const stableTieBreak = (first, second) => (
  compareNullableNumbers(first.rowNum, second.rowNum) || first.originalIndex - second.originalIndex
);

const compareOfscNr = (first, second) => {
  const firstText = String(first.ofscNr ?? '').trim();
  const secondText = String(second.ofscNr ?? '').trim();
  return firstText.localeCompare(secondText, 'tr', { numeric: true });
};

const statusCodeFromDescription = (value) => {
  const normalized = String(value ?? '').toLocaleLowerCase('tr').trim();
  if (normalized === 'bucket') return 0;
  if (normalized === 'pending') return 3;
  if (normalized === 'started') return 4;
  if (normalized === 'completed') return 6;
  if (normalized === 'road') return 7;
  return null;
};

const normalizeRawRow = (row, originalIndex, day) => {
  const appointmentMinutes = parseTimeMinutes(readField(row, FIELD_ALIASES.appointmentTime));
  const startedMinutes = parseTimeMinutes(readField(row, FIELD_ALIASES.startedAt));
  const departedMinutes = parseTimeMinutes(readField(row, FIELD_ALIASES.departedAt))
    ?? startedMinutes;
  const rawStatusDescription = readField(row, FIELD_ALIASES.statusDescription);
  const rawStatusCode = parseInteger(readField(row, FIELD_ALIASES.toaStatus), null)
    ?? parseInteger(rawStatusDescription, null)
    ?? statusCodeFromDescription(rawStatusDescription);
  const appointmentDate = parseLocalDateTime(
    readField(row, FIELD_ALIASES.appointmentDate),
    day,
    appointmentMinutes,
  );
  const rawTechWorkStart = readField(row, FIELD_ALIASES.techWorkStart);
  const rawTechWorkEnd = readField(row, FIELD_ALIASES.techWorkEnd);
  return {
    source: row,
    originalIndex,
    ofscNr: readField(row, FIELD_ALIASES.ofscNr),
    techCode: readField(row, FIELD_ALIASES.techCode),
    userTechCode: readField(row, FIELD_ALIASES.userTechCode),
    techName: readField(row, FIELD_ALIASES.techName),
    appointmentDate,
    appointmentEndText: readField(row, FIELD_ALIASES.appointmentEndText),
    toaStatus: rawStatusCode,
    neighbourhood: readField(row, FIELD_ALIASES.neighbourhood) ?? '',
    latitude: parseLocaleNumber(readField(row, FIELD_ALIASES.latitude)),
    longitude: parseLocaleNumber(readField(row, FIELD_ALIASES.longitude)),
    workDuration: parseInteger(readField(row, FIELD_ALIASES.workDuration), 0),
    // Değer yoksa null bırakılır: teknisyenin o gün takvimi/mesaisi kapalı demektir.
    // (Zaman çizelgesi hesapları runTimeIteration içinde kendi varsayılanını uygular.)
    techWorkStart: isNullishValue(rawTechWorkStart) ? null : rawTechWorkStart,
    techWorkEnd: isNullishValue(rawTechWorkEnd) ? null : rawTechWorkEnd,
    rowNum: parseInteger(readField(row, FIELD_ALIASES.rowNum), originalIndex + 1),
    appointmentTime: readField(row, FIELD_ALIASES.appointmentTime) || '',
    appointmentTimeEnd: readField(row, FIELD_ALIASES.appointmentTimeEnd)
      || readField(row, FIELD_ALIASES.appointmentEndText)
      || '',
    appointmentMinutes,
    appointmentEndMinutes: parseTimeMinutes(
      readField(row, FIELD_ALIASES.appointmentTimeEnd)
      || readField(row, FIELD_ALIASES.appointmentEndText),
    ),
    departedMinutes,
    startedMinutes,
    completedMinutes: parseTimeMinutes(readField(row, FIELD_ALIASES.completedAt)),
    statusDescription: parseLocaleNumber(rawStatusDescription) == null
      ? rawStatusDescription
      : undefined,
    products: normalizeTextValue(readField(row, FIELD_ALIASES.products)),
    servicePapers: normalizeTextValue(readField(row, FIELD_ALIASES.servicePapers)),
    servicePapersStatus: normalizeTextValue(readField(row, FIELD_ALIASES.servicePapersStatus)),
    dealer: normalizeTextValue(readField(row, FIELD_ALIASES.dealer)),
    customer: normalizeTextValue(readField(row, FIELD_ALIASES.customer)),
    appReason: normalizeTextValue(readField(row, FIELD_ALIASES.appReason)),
  };
};

const rowKey = row => `${String(row.techCode)}::${String(row.ofscNr)}`;
const isRealJob = row => String(row.ofscNr ?? '').trim() !== '0';

const createEnrichmentMap = (source) => {
  if (!source) return new Map();
  if (source instanceof Map) return source;

  const result = new Map();
  if (Array.isArray(source)) {
    source.forEach((item) => {
      if (!item || typeof item !== 'object') return;
      const key = readField(item, FIELD_ALIASES.ofscNr);
      if (!isNullishValue(key)) result.set(String(key).trim(), item);
    });
    return result;
  }

  if (typeof source === 'object') {
    Object.entries(source).forEach(([key, value]) => {
      if (value && typeof value === 'object') result.set(String(key).trim(), value);
    });
  }
  return result;
};

const getServiceCenter = (rows, suppliedCenter) => {
  const suppliedLatitude = parseLocaleNumber(
    suppliedCenter?.latitude ?? suppliedCenter?.Latitude ?? suppliedCenter?.lat,
  );
  const suppliedLongitude = parseLocaleNumber(
    suppliedCenter?.longitude ?? suppliedCenter?.Longitude ?? suppliedCenter?.lng,
  );
  const isValidCoordinate = value => value != null && value !== 0;
  const bucketRows = rows.filter(
    row => String(row.neighbourhood).toLocaleLowerCase('tr').trim() === 'bucket',
  );
  const bucketRow = bucketRows.find(
    row => isValidCoordinate(row.latitude) && isValidCoordinate(row.longitude),
  ) || bucketRows[0];
  const serviceRow = rows.find(row => (
    !isRealJob(row)
    && String(row.neighbourhood).toLocaleLowerCase('tr').trim() === 'servis'
  ));
  return {
    latitude: isValidCoordinate(bucketRow?.latitude)
      ? bucketRow.latitude
      : suppliedLatitude ?? serviceRow?.latitude ?? 0,
    longitude: isValidCoordinate(bucketRow?.longitude)
      ? bucketRow.longitude
      : suppliedLongitude ?? serviceRow?.longitude ?? 0,
  };
};

const fillMissingCoordinatePairs = (rows, center) => rows.map(row => (
  row.latitude == null && row.longitude == null
    ? { ...row, latitude: center.latitude, longitude: center.longitude }
    : row
));

const squaredDistance = (from, to) => {
  if (
    from?.latitude == null
    || from?.longitude == null
    || to?.latitude == null
    || to?.longitude == null
  ) {
    // SQL Server'da ORDER BY ... ASC sırasında NULL değerler önce gelir.
    return Number.NEGATIVE_INFINITY;
  }
  return ((from.latitude - to.latitude) ** 2) + ((from.longitude - to.longitude) ** 2);
};

const buildSpatialOrder = (rows, center, latestActiveRows = rows) => {
  const realRows = rows.filter(isRealJob);
  const rowsByTech = groupByTechnician(realRows);
  const techCodes = [...rowsByTech.keys()];
  const currentPositions = new Map();
  const pendingByTech = new Map(techCodes.map(techCode => [techCode, []]));

  techCodes.forEach((techCode) => {
    const techRows = rowsByTech.get(techCode) || [];
    const lastKnown = techRows
      .filter(row => String(row.techCode) === techCode && [4, 6, 7].includes(row.toaStatus))
      .sort((first, second) => (
        lastLocationPriority(second.toaStatus) - lastLocationPriority(first.toaStatus)
        || compareDates(second.appointmentDate, first.appointmentDate)
        || stableTieBreak(first, second)
      ))[0];
    currentPositions.set(techCode, {
      latitude: lastKnown?.latitude ?? center.latitude,
      longitude: lastKnown?.longitude ?? center.longitude,
    });
    const uniqueTimes = [...new Set(
      techRows
        .filter(row => ![1, 4, 6, 7].includes(row.toaStatus))
        .map(row => row.appointmentDate?.getTime() ?? Number.POSITIVE_INFINITY),
    )].sort((first, second) => first - second);
    const appointmentRanks = new Map(uniqueTimes.map((time, index) => [time, index + 1]));
    pendingByTech.set(
      techCode,
      techRows
        .filter(row => ![1, 4, 6, 7].includes(row.toaStatus))
        .map(row => ({
          ...row,
          spatialPriority: appointmentRanks
            .get(row.appointmentDate?.getTime() ?? Number.POSITIVE_INFINITY) ?? 1,
        })),
    );
  });

  let latestActive = null;
  latestActiveRows.filter(isRealJob).forEach((row) => {
    if (![1, 4, 6, 7].includes(row.toaStatus)) return;
    if (
      !latestActive
      || (row.departedMinutes ?? Number.NEGATIVE_INFINITY)
        > (latestActive.departedMinutes ?? Number.NEGATIVE_INFINITY)
      || (
        row.departedMinutes === latestActive.departedMinutes
        && stableTieBreak(row, latestActive) < 0
      )
    ) latestActive = row;
  });
  if (latestActive) {
    pendingByTech.get(String(latestActive.techCode))
      ?.push({ ...latestActive, spatialPriority: 0 });
  }

  const result = new Map();
  for (let sequence = 1; sequence <= 100; sequence += 1) {
    let selectedCount = 0;
    techCodes.forEach((techCode) => {
      const position = currentPositions.get(techCode);
      const pool = pendingByTech.get(techCode) || [];
      if (pool.length === 0) return;
      let nextIndex = 0;
      for (let index = 1; index < pool.length; index += 1) {
        const comparison = (
          pool[index].spatialPriority - pool[nextIndex].spatialPriority
          || squaredDistance(position, pool[index]) - squaredDistance(position, pool[nextIndex])
          || compareOfscNr(pool[index], pool[nextIndex])
          || stableTieBreak(pool[index], pool[nextIndex])
        );
        if (comparison < 0) nextIndex = index;
      }
      const next = pool[nextIndex];
      selectedCount += 1;
      result.set(rowKey(next), sequence);
      currentPositions.set(techCode, {
        latitude: next.latitude,
        longitude: next.longitude,
      });
      const selectedKey = rowKey(next);
      pendingByTech.set(
        techCode,
        pool.filter(row => rowKey(row) !== selectedKey),
      );
    });
    if (selectedCount === 0) break;
  }
  return result;
};

const groupByTechnician = (rows) => {
  const groups = new Map();
  rows.forEach((row) => {
    const key = String(row.techCode);
    if (!groups.has(key)) groups.set(key, []);
    groups.get(key).push(row);
  });
  return groups;
};

const applyFixedCoordinates = (orderedRows, center) => orderedRows.map((row, index) => {
  const previous = orderedRows[index - 1];
  let fixedLatitude = row.latitude;
  let fixedLongitude = row.longitude;
  if (!isRealJob(row) && index === 0) {
    fixedLatitude = center.latitude ?? row.latitude;
    fixedLongitude = center.longitude ?? row.longitude;
  } else if (!isRealJob(row)) {
    fixedLatitude = previous?.latitude ?? row.latitude;
    fixedLongitude = previous?.longitude ?? row.longitude;
  }
  return {
    ...row,
    latitude: fixedLatitude ?? row.latitude,
    longitude: fixedLongitude ?? row.longitude,
  };
});

// const estimateTravelMinutes = (previous, current) => {
//   if (!isRealJob(current)) return 0;
//   if (
//     previous?.latitude == null
//     || previous?.longitude == null
//     || current.latitude == null
//     || current.longitude == null
//   ) return 15;
//   const latDiff = (current.latitude - previous.latitude) * Math.PI / 360;
//   const lonDiff = (current.longitude - previous.longitude) * Math.PI / 360;
//   const haversine = (
//     Math.sin(latDiff) ** 2
//     + Math.cos(previous.latitude * Math.PI / 180)
//       * Math.cos(current.latitude * Math.PI / 180)
//       * Math.sin(lonDiff) ** 2
//   );
//   const km = 12742 * Math.asin(Math.sqrt(Math.max(0, Math.min(1, haversine))));
//   const estimatedRoadKm = km * 1.4;
//   const averageSpeed = estimatedRoadKm < 10 ? 30 : 60;
//   return Math.min(60, 10 + Math.trunc((estimatedRoadKm / averageSpeed) * 60));
// };


// Dereceyi radyana çeviren sabit katsayı (Her hesaplamada bölme yapmamak için)
const DEG_TO_RAD = Math.PI / 180;

const estimateTravelMinutes = (previous, current) => {
  if (!isRealJob(current)) return 0;
  if (String(current.neighbourhood || '').toLocaleLowerCase('tr').trim() === 'yemek') return 0;

  const lat1 = previous?.latitude;
  const lon1 = previous?.longitude;
  const lat2 = current?.latitude;
  const lon2 = current?.longitude;

  // Koordinat eksikse varsayılan süre
  if (lat1 == null || lon1 == null || lat2 == null || lon2 == null) return 15;

  // Aynı konumdalarsa boşuna matematik yapma
  if (lat1 === lat2 && lon1 === lon2) return 5;

  // 1. PERFORMANS: Equirectangular Mesafe Hesabı
  // Şehir içi/bölgesel mesafelerde Haversine'e göre ~3x daha hızlıdır ve doğruluk payı %99.9 aynıdır.
  const lat1Rad = lat1 * DEG_TO_RAD;
  const lat2Rad = lat2 * DEG_TO_RAD;
  const dLat = lat2Rad - lat1Rad;
  const dLon = (lon2 - lon1) * DEG_TO_RAD;

  const x = dLon * Math.cos((lat1Rad + lat2Rad) * 0.5);
  const km = Math.sqrt(x * x + dLat * dLat) * 6371;

  // 2. DOĞRULUK: Dinamik Yol Katsayısı (Detour Factor)
  // Kısa mesafelerde ara sokak/ışık çok olduğu için katsayı yüksek (1.45), uzun yolda düşük (1.25)
  const detourFactor = km < 5 ? 1.45 : (km < 20 ? 1.35 : 1.25);
  const roadKm = km * detourFactor;

  // 3. DOĞRULUK: Kademeli Hız Hesabı (Discontinuity / Sıçrama Önleyici)
  // 0-3 km -> 25 km/sa | 3-15 km -> 25'ten 50'ye yumuşak tırmanış | 15+ km -> 60 km/sa
  let speed = 25;
  if (roadKm > 15) {
    speed = 60;
  } else if (roadKm > 3) {
    speed = 25 + ((roadKm - 3) / 12) * 25; // Sıçramayı engeller
  }

  // 4. DOĞRULUK: Dinamik Hazırlık/Park Süresi (Buffer)
  // 500 metrelik işe 10 dk park süresi eklemek yerine mesafeye göre ölçeklendirme
  const bufferMinutes = roadKm < 2 ? 5 : (roadKm < 10 ? 6 : 10);

  const travelTime = (roadKm / speed) * 60;

  return Math.min(90, Math.round(bufferMinutes + travelTime));
};

const orderRows = (rows, spatialOrder, center, secondPass = false) => {
  const output = [];
  groupByTechnician(rows).forEach((techRows) => {
    const ordered = [...techRows].sort((first, second) => (
      statusPriority(second.toaStatus) - statusPriority(first.toaStatus)
      || (secondPass
        ? compareDates(first.newSortTime, second.newSortTime)
        : compareDates(first.appointmentDate, second.appointmentDate))
      || (spatialOrder.get(rowKey(first)) ?? 999) - (spatialOrder.get(rowKey(second)) ?? 999)
      || stableTieBreak(first, second)
    ));
    const fixed = applyFixedCoordinates(ordered, center);
    fixed.forEach((row, index) => {
      const previous = index === 0 ? center : fixed[index - 1];
      const isYemek = String(row.neighbourhood || '').toLocaleLowerCase('tr').trim() === 'yemek';
      output.push({
        ...row,
        travelDuration: isYemek ? 0 : estimateTravelMinutes(previous, row),
        sortIndex: index + 1,
      });
    });
  });
  return output;
};

const runTimeIteration = (rows, day, now) => {
  const output = [];
  groupByTechnician(rows).forEach((techRows) => {
    let previousFinish = null;
    techRows
      .sort((first, second) => first.sortIndex - second.sortIndex)
      .forEach((row, index) => {
        const workStartMinutes = parseTimeMinutes(row.techWorkStart) ?? 8 * 60;
        const shiftStart = dateAtMinutes(day, workStartMinutes);
        const nowAtMinute = new Date(now);
        nowAtMinute.setSeconds(0, 0);
        const isLiveToday = sameLocalDay(day, now) && now > shiftStart;
        const techRefTime = isLiveToday ? nowAtMinute : shiftStart;
        const appointmentStart = dateAtMinutes(
          day,
          row.appointmentMinutes ?? parseTimeMinutes(row.appointmentTime) ?? workStartMinutes,
        );
        const isYemekRow = String(row.neighbourhood || '').toLocaleLowerCase('tr').trim() === 'yemek';
        const plannedDeparture = addMinutes(appointmentStart, -row.travelDuration);
        const actualDeparture = dateAtMinutes(day, row.departedMinutes);
        // Yemek için techRefTime alt sınırı uygulanmaz; randevu saati korunur
        let departure = actualDeparture || maxDate(
          index > 0 ? previousFinish : (isYemekRow ? null : (isLiveToday ? techRefTime : null)),
          plannedDeparture,
        );
        // Pending: planlanan yola çıkış geçmişte kaldıysa şimdi
        if (!actualDeparture && sameLocalDay(day, now) && departure && departure < now) {
          departure = new Date(now);
        }
        const actualArrival = dateAtMinutes(day, row.startedMinutes);
        let arrival = actualArrival || addMinutes(departure, row.travelDuration);
        // Yola çıkıldı ama ulaşılmadıysa: planlanan varış geçtiyse şu an, geçmediyse planlanan
        if (!actualArrival && actualDeparture && !isYemekRow && sameLocalDay(day, now)) {
          const plannedArrival = addMinutes(actualDeparture, row.travelDuration);
          arrival = plannedArrival > now ? plannedArrival : new Date(now);
        } else if (!actualArrival && !isYemekRow && sameLocalDay(day, now) && arrival < now) {
          arrival = new Date(now);
        }
        const actualCompletion = dateAtMinutes(day, row.completedMinutes);
        const plannedCompletion = addMinutes(arrival, row.workDuration);
        // Başlandı ama tamamlanmadıysa: planlanan bitiş geçtiyse şu an, geçmediyse planlanan
        const completion = actualCompletion
          || (actualArrival && !actualCompletion && sameLocalDay(day, now) && plannedCompletion <= now
            ? new Date(now)
            : plannedCompletion);
        const previousBoundary = index === 0 ? techRefTime : previousFinish;
        output.push({
          ...row,
          techRefTime,
          departure,
          arrival,
          completion,
          previousBoundary,
        });
        previousFinish = completion;
      });
  });
  return output;
};

const resolveStatusDescription = (row, descriptions) => {
  const toaStatusDescription = resolveToaStatusDescription(row.toaStatus);
  if (toaStatusDescription) return toaStatusDescription;
  if (!isNullishValue(row.statusDescription)) return row.statusDescription;
  return descriptions[row.toaStatus] || 'pending';
};

const isRawSchedulingResponse = (rows) => {
  const hasExplicitRawFields = rows.some(row => (
    Object.prototype.hasOwnProperty.call(row, 'OFSC_NR')
    || Object.prototype.hasOwnProperty.call(row, 'TEKNISYEN_KODU')
    || Object.prototype.hasOwnProperty.call(row, 'TOA_DURUM')
    || Object.prototype.hasOwnProperty.call(row, 'toa_durum')
    || Object.prototype.hasOwnProperty.call(row, 'RANDEVU_TARIHI')
    || Object.prototype.hasOwnProperty.call(row, 'RandevuTarihi')
    || Object.prototype.hasOwnProperty.call(row, 'RowNum')
    || Object.prototype.hasOwnProperty.call(row, 'SURE')
    || Object.prototype.hasOwnProperty.call(row, 'Sure')
    || Object.prototype.hasOwnProperty.call(row, 'ToaDurum')
    || Object.prototype.hasOwnProperty.call(row, 'toaDurum')
    || Object.prototype.hasOwnProperty.call(row, 'ToaStatus')
    || Object.prototype.hasOwnProperty.call(row, 'toaStatus')
  ));
  if (hasExplicitRawFields) return true;

  const hasSchedulingIdentity = rows.some(row => (
    readField(row, FIELD_ALIASES.techCode) != null
    && readField(row, FIELD_ALIASES.ofscNr) != null
    && readField(row, FIELD_ALIASES.appointmentTime) != null
  ));
  if (!hasSchedulingIdentity) return false;

  const hasCalculatedOrder = rows.some(row => (
    parseInteger(row.SortOrder ?? row.sortOrder, 0) > 0
  ));
  const hasCalculatedTimeline = rows.some(row => (
    !isNullishValue(row.DepartureTime ?? row.departureTime)
    && !isNullishValue(row.ArrivalatCustomer ?? row.arrivalatCustomer)
    && !isNullishValue(row.TaskCompletionTime ?? row.taskCompletionTime)
  ));
  return !hasCalculatedOrder || !hasCalculatedTimeline;
};

/**
 * GetAronToaSchedulingAvailable ham sonucunu SQL'deki iki aşamalı planlama
 * hesabıyla ekranın beklediği modele dönüştürür.
 */
export const calculateToaScheduling = (rawRows, options = {}) => {


  if (!Array.isArray(rawRows) || rawRows.length === 0) return [];
  if (!isRawSchedulingResponse(rawRows)) return rawRows;

  const firstRawDate = readField(rawRows[0], FIELD_ALIASES.appointmentDate);
  const day = startOfLocalDay(options.dayDate)
    || startOfLocalDay(parseLocalDateTime(firstRawDate))
    || startOfLocalDay(new Date());
  const now = options.now instanceof Date ? new Date(options.now) : new Date(options.now || Date.now());
  const enrichmentByOfscNr = createEnrichmentMap(options.enrichmentByOfscNr);
  const normalized = rawRows.map((row, index) => {
    const ofscNr = readField(row, FIELD_ALIASES.ofscNr);
    const enrichment = enrichmentByOfscNr.get(String(ofscNr ?? '').trim());
    return normalizeRawRow(enrichment ? { ...row, ...enrichment } : row, index, day);
  });
  const center = getServiceCenter(normalized, options.serviceCenter);
  const allRows = fillMissingCoordinatePairs(normalized, center);
  const technicianFilter = Array.isArray(options.technicianFilter)
    ? new Set(options.technicianFilter.map(value => String(value)))
    : null;
  const rows = technicianFilter
    ? allRows.filter(row => technicianFilter.has(String(row.techCode)))
    : allRows;
  const spatialOrder = buildSpatialOrder(rows, center, allRows);

  const firstOrdered = orderRows(rows, spatialOrder, center);
  const firstIteration = runTimeIteration(firstOrdered, day, now).map(row => {
    const appointmentEnd = dateAtMinutes(day, row.appointmentEndMinutes);
    const isCompliant = Boolean(appointmentEnd && row.arrival <= appointmentEnd);
    const isYemek = String(row.neighbourhood).toLocaleLowerCase('tr').trim() === 'yemek';
    return {
      ...row,
      appointmentCompliance: isCompliant ? 1 : 0,
      newSortTime: isCompliant
        ? row.arrival
        : dateAtMinutes(
            day,
            row.appointmentEndMinutes != null
              ? row.appointmentEndMinutes - (isYemek ? 0 : 30)
              : (row.appointmentMinutes ?? parseTimeMinutes(row.appointmentTime)),
          ),
    };
  });

  const secondOrdered = orderRows(firstIteration, spatialOrder, center, true);
  const finalRows = runTimeIteration(secondOrdered, day, now);
  const statusDescriptions = {
    ...DEFAULT_STATUS_DESCRIPTIONS,
    ...(options.statusDescriptions || {}),
  };

  const result = finalRows
    .map((row) => {
      const idleDuration = Math.max(0, diffSqlMinutes(row.previousBoundary, row.departure));
      const isServiceShop = options.serviceShopId != null
        && String(row.techCode) === String(options.serviceShopId);
      const isYemekOutput = String(row.neighbourhood || '').toLocaleLowerCase('tr').trim() === 'yemek';
      return {
        ...row.source,
        TechCode: row.techCode,
        UserTechCode: row.userTechCode,
        TechName: row.techName,
        OfscNr: row.ofscNr,
        Neighbourhood: row.neighbourhood,
        LATITUDE: row.latitude,
        LONGITUDE: row.longitude,
        StatusDescription: isServiceShop
          ? 'Bucket'
          : resolveStatusDescription(row, statusDescriptions),
        AppointmentTime: row.appointmentTime,
        AppointmentTimeEnd: row.appointmentTimeEnd,
        RandevuyaUyum: row.appointmentCompliance,
        DepartureTime: formatTime(row.departure),
        ArrivalatCustomer: formatTime(row.arrival),
        TaskCompletionTime: formatTime(row.completion),
        IdleTimeStart: idleDuration > 0 ? formatTime(row.previousBoundary) : '-',
        IdleTimeEnd: idleDuration > 0 ? formatTime(row.departure) : '-',
        IdleDuration: idleDuration,
        WorkDuration: row.workDuration,
        TravelDuration: isYemekOutput ? 0 : row.travelDuration,
        Products: row.products,
        ServicePapers: row.servicePapers,
        Dealer: row.dealer,
        Customer: row.customer,
        CustomerName: row.customer,
        AppReason: row.appReason,
        ApplicationReason: row.appReason,
        TechWorkStart: formatTime(dateAtMinutes(day, parseTimeMinutes(row.techWorkStart))),
        TechWorkEnd: formatTime(dateAtMinutes(day, parseTimeMinutes(row.techWorkEnd))),
        SortOrder: row.sortIndex,
        ServicePapersStatus: row.servicePapersStatus,
      };
    })
    .filter(row => String(row.Neighbourhood ?? '') !== '');

  const serviceShop = options.serviceShop || {};
  const serviceTechCode = serviceShop.techCode
    ?? serviceShop.TechCode
    ?? options.serviceShopId;
  const technicianWorkStarts = rows
    .map(row => parseTimeMinutes(row.techWorkStart))
    .filter(value => value != null);
  const technicianWorkEnds = rows
    .map(row => parseTimeMinutes(row.techWorkEnd))
    .filter(value => value != null);
  const serviceWorkStartMinutes = parseTimeMinutes(
    serviceShop.techWorkStart ?? serviceShop.TechWorkStart,
  ) ?? (technicianWorkStarts.length > 0 ? Math.min(...technicianWorkStarts) : 8 * 60);
  const serviceWorkEndMinutes = parseTimeMinutes(
    serviceShop.techWorkEnd ?? serviceShop.TechWorkEnd,
  ) ?? (technicianWorkEnds.length > 0 ? Math.max(...technicianWorkEnds) : 18 * 60);
  const hasBucketRow = result.some(row => (
    String(row.StatusDescription).toLocaleLowerCase('tr').trim() === 'bucket'
  ));
  if (serviceTechCode != null && String(serviceTechCode).trim() !== '' && !hasBucketRow) {
    result.push({
      TechCode: serviceTechCode,
      UserTechCode: serviceShop.userTechCode ?? serviceShop.UserTechCode ?? '',
      TechName: serviceShop.techName ?? serviceShop.TechName ?? '',
      OfscNr: '0',
      Neighbourhood: 'Servis',
      LATITUDE: center.latitude,
      LONGITUDE: center.longitude,
      StatusDescription: 'Bucket',
      AppointmentTime: '-',
      AppointmentTimeEnd: '',
      RandevuyaUyum: 0,
      DepartureTime: '',
      ArrivalatCustomer: '-',
      TaskCompletionTime: '-',
      IdleTimeStart: '-',
      IdleTimeEnd: '-',
      IdleDuration: 0,
      WorkDuration: 60,
      TravelDuration: 0,
      Products: '',
      ServicePapers: '',
      TechWorkStart: formatTime(dateAtMinutes(day, serviceWorkStartMinutes)),
      TechWorkEnd: formatTime(dateAtMinutes(day, serviceWorkEndMinutes)),
      SortOrder: 9998,
      ServicePapersStatus: '',
    });
  }

  return result.sort((first, second) => (
      String(first.TechCode).localeCompare(String(second.TechCode), 'tr', { numeric: true })
      || first.SortOrder - second.SortOrder
      || String(first.DepartureTime === '-' ? '23:59' : first.DepartureTime)
        .localeCompare(String(second.DepartureTime === '-' ? '23:59' : second.DepartureTime))
    ));
};

export default calculateToaScheduling;
